import BaseAPIClient from "../base/BaseAPIClient";
import moment from 'moment';

export default class CreditReportsClient extends BaseAPIClient {

  getBinnedUsageReport(schoolId, from, through, binBy, customCampusTags) {
    return this._get('v2/campus-administration/reports/credits/binned-usage/', {
      schoolId,
      from: from ? moment(from).toISOString() : null,
      through: through ? moment(through).toISOString() : null,
      binBy,
      customCampusTags,
    });
  }

  getForecastReport(schoolId) {
    return this._get('v2/campus-administration/reports/credits/forecast/', {
      schoolId
    });
  }

  getCountsReport(schoolId, from, through, customCampusTags) {
    return this._get('v2/campus-administration/reports/credits/counts/', {
      schoolId,
      from: from ? moment(from).toISOString() : null,
      through: through ? moment(through).toISOString() : null,
      customCampusTags,
    });
  }

  getLedgerReport({schoolId, from, through, type, pageToken, customCampusTags}) {
    return this._get('v2/campus-administration/reports/credits/ledger/', {
      schoolId,
      from: from ? moment(from).toISOString() : null,
      through: through ? moment(through).toISOString() : null,
      type,
      pageToken,
      customCampusTags
    });
  }
}